// Sizes
const mainHeader = document.querySelector('.site-header');
let headerExpandedHeight = 100;
let headerShrunkHeight   = 80;

// Lock header logic during programmatic scrolls
let __progScroll = false;

// WP Admin Bar support
function getAdminBarHeight() {
  const adminBar = document.getElementById('wpadminbar');
  if (!adminBar) return 0;
  return adminBar.offsetHeight || 0;
}

// Utils
function getHeaderOffset() {
  return document.querySelector('.site-header')?.offsetHeight || 0;
}

// Cached shrunk height on ≥992px, else live height
function getShrunkHeaderOffset() {
  if (window.matchMedia("(min-width: 992px)").matches) return headerShrunkHeight;
  return getHeaderOffset();
}

// Sync body top padding with fixed header
function updateHeaderOffsetPadding() {
  if (__progScroll) return;
  const body = document.body;
  const header = document.querySelector('.site-header');
  if (!header) return;

  const isOverlay = header.classList.contains('header-overlay');
  const isFixed   = header.classList.contains('header-fixed');

  if (isOverlay) { body.style.paddingTop = ''; return; }
  body.style.paddingTop = isFixed ? `${header.offsetHeight}px` : '';
}

// Debounced ScrollTrigger.refresh
let refreshTimeout;
function safeRefresh() {
  clearTimeout(refreshTimeout);
  refreshTimeout = setTimeout(() => ScrollTrigger.refresh(), 100);
}

// Fixed header behavior
function toggleFixed() {
  if (!mainHeader || __progScroll) return;
  const adminBarHeight = getAdminBarHeight();
  
  if (window.scrollY > 0) {
    mainHeader.classList.add("header-fixed");
    mainHeader.style.top = `${adminBarHeight}px`;
  } else {
    mainHeader.classList.remove("header-fixed");
    mainHeader.style.top = '';
  }
  updateHeaderOffsetPadding();
}

function toggleHeaderClass() {
  if (!mainHeader || __progScroll) return;

  const isScrolled = window.scrollY > 0;
  const hasClass   = mainHeader.classList.contains("header-fixed");
  const isOverlay  = mainHeader.classList.contains("header-overlay");
  const adminBarHeight = getAdminBarHeight();

  if (isScrolled && !hasClass) {
    if (!isOverlay) {
      const startHeight = mainHeader.offsetHeight;
      document.body.style.paddingTop = `${startHeight}px`;
    }
    gsap.to(mainHeader, {
      height: headerShrunkHeight,
      duration: 0.3,
      ease: "power2.out",
      onStart: () => {
        mainHeader.classList.add("header-fixed");
        mainHeader.style.top = `${adminBarHeight}px`;
      },
      onUpdate: () => { if (!isOverlay) updateHeaderOffsetPadding(); },
      onComplete: () => { updateHeaderOffsetPadding(); ScrollTrigger.refresh(); }
    });
  } else if (!isScrolled && hasClass) {
    gsap.to(mainHeader, {
      height: headerExpandedHeight,
      duration: 0.3,
      ease: "power2.out",
      onUpdate: () => { if (!isOverlay) updateHeaderOffsetPadding(); },
      onComplete: () => {
        mainHeader.classList.remove("header-fixed");
        mainHeader.style.top = '';
        updateHeaderOffsetPadding();
        ScrollTrigger.refresh();
      }
    });
  }
}

function setupHeaderBehavior() {
  if (!mainHeader) return;

  const isWide = window.matchMedia("(min-width: 992px)").matches;

  window.removeEventListener("scroll", toggleFixed);
  window.removeEventListener("scroll", toggleHeaderClass);

  if (!isWide) {
    gsap.set(mainHeader, { clearProps: "height" });
    updateHeaderOffsetPadding();
    toggleFixed();
    window.addEventListener("scroll", toggleFixed, { passive: true });

    stickyLabels.forEach(label => gsap.set(label, { clearProps: "all" }));
    stickyHeaders.forEach(header => gsap.set(header, { clearProps: "all" }));
  } else {
    headerExpandedHeight = mainHeader.offsetHeight;
    
    // Base shrunk height for header content
    let baseHeaderHeight = 80;
    
    // Check if banner exists and add its height
    const banner = document.querySelector('.site-banner');
    const bannerHeight = banner ? banner.offsetHeight : 0;
    
    headerShrunkHeight = baseHeaderHeight + bannerHeight;
    
    toggleHeaderClass();
    window.addEventListener("scroll", toggleHeaderClass, { passive: true });
  }
}

window.addEventListener("load", setupHeaderBehavior);
window.addEventListener("resize", setupHeaderBehavior);

// ScrollTrigger batches
let mediaMatch = gsap.matchMedia();

mediaMatch.add("(max-width: 1199px)", () => {
  ScrollTrigger.batch(".jsInView", { toggleClass: "in-view", start: 'top 50%' });
});

mediaMatch.add("(min-width: 1200px)", () => {
  ScrollTrigger.batch(".jsInView", {
    toggleClass: "in-view",
    start: () => `top+=${getShrunkHeaderOffset()} top`,
  });
});

ScrollTrigger.batch(".jsInView50", { toggleClass: "in-view", start: 'top 50%' });

// Logo animation on load
$(function () {
  $('.jsBranding').addClass('is-animated is-loaded is-animating');
  // Remove is-animating after the staggered intro finishes (longest delay 0.6s + transition 0.6s = 1.2s)
  // so future resizes scale immediately without the delay.
  setTimeout(() => $('.jsBranding').removeClass('is-animating'), 1300);
});

// Office fade-in
$(function () {
  if ($('.jsOffice').length > 0) {
    setTimeout(() => $('.jsOffice').addClass('in-view'), 500);
  }
});

// Sticky sidebar labels (≥992px)
const stickyLabels = gsap.utils.toArray('.jsFixedLabel');

stickyLabels.forEach((label) => {
  let mediaMatch = gsap.matchMedia();
  let endTrigger = label.closest('section');

  mediaMatch.add("(min-width: 992px)", () => {
    gsap.to(label, {
      scrollTrigger: {
        trigger: label,
        start: () => `top-=${getShrunkHeaderOffset() + 20} top`,
        endTrigger: endTrigger,
        end: 'bottom 25%',
        pin: true,
        scrub: true,
      }
    });
  });
});

// Sticky section headers (≥1200px)
const stickyHeaders = gsap.utils.toArray('.jsFixedHeader');

stickyHeaders.forEach((headers, index) => {
  const nextHeader = stickyHeaders[index + 1];
  let mediaMatch = gsap.matchMedia();

  const setupPin = (getOffsetFn) => {
    const isLast = !nextHeader;
    const endTrigger = isLast ? '#workBlock' : nextHeader;
    return {
      trigger: headers,
      start: () => `top-=${getOffsetFn()} top`,
      endTrigger,
      end: isLast ? 'bottom bottom' : 'top top',
      pin: true,
      scrub: true,
      onEnter: () => {
        stickyHeaders.forEach((h) => { if (h !== headers) h.style.position = 'static'; });
      },
    };
  };

  mediaMatch.add("(min-width: 1200px)", () => {
    gsap.to(headers, { scrollTrigger: setupPin(getShrunkHeaderOffset) });
  });
});

// Lottie scroll watchers
$('.lottie-img').each(function () {
  let lottiePlayer = $('#' + $(this).attr('id'));

  function lottiePlay()  { if (!lottiePlayer[0].isPaused) lottiePlayer[0].play(); }
  function lottiePause() { lottiePlayer[0].pause(); lottiePlayer.removeAttr('loop'); }

  function checkIfInView() {
    if (lottiePlayer.closest('[class*="jsInView"]').hasClass('in-view')) lottiePlay();
    else lottiePause();
  }

  checkIfInView();
  $(window).on('scroll', checkIfInView);
});

// Final refresh/padding sync
window.addEventListener("load", () => {
  setTimeout(() => { ScrollTrigger.refresh(); updateHeaderOffsetPadding(); }, 100);
});
window.addEventListener("resize", () => { updateHeaderOffsetPadding(); safeRefresh(); });

// Landing page twinkles
const twinkleTargets = document.querySelectorAll('#twinkle-svg path');

function getBaseOpacity(el) {
  const attr = el.getAttribute('opacity');
  if (attr != null && !isNaN(parseFloat(attr))) return parseFloat(attr);
  const n = parseFloat(getComputedStyle(el).opacity);
  return isNaN(n) ? 1 : n;
}

function twinkle(el) {
  if (!el.isConnected) return;
  const base = parseFloat(el.dataset.baseOpacity) || 1;
  const outDur  = gsap.utils.random(1.8, 3.2);
  const hold0   = gsap.utils.random(0.5, 1.4);
  const inDur   = gsap.utils.random(1.8, 3.2);
  const gapWait = gsap.utils.random(2.0, 5.5);
  const doScale = Math.random() < 0.12;

  gsap.timeline({ defaults: { ease: "sine.inOut" } })
    .to(el, { opacity: 0, duration: outDur })
    .to(el, {
      opacity: base,
      duration: inDur,
      delay: hold0,
      scale: doScale ? gsap.utils.random(0.98, 1.03) : 1,
      transformOrigin: "50% 50%"
    })
    .add(() => gsap.delayedCall(gapWait, () => twinkle(el)));
}

twinkleTargets.forEach((el) => {
  const base = getBaseOpacity(el);
  el.dataset.baseOpacity = String(base);
  gsap.set(el, { opacity: base });
  gsap.delayedCall(gsap.utils.random(0, 5), () => twinkle(el));
});

// Smooth scroll to #landing-sidebar (offset 80px) + focus first field
(function () {
  function initSmoothScroll() {
    const trigger = document.getElementById('scroll-sidebar');
    const target  = document.getElementById('landing-sidebar');
    if (!trigger || !target) return;

    const OFFSET = 80; // set to 85 if needed

    // find the first real, focusable field inside target
    function focusFirstField(container) {
      const fields = container.querySelectorAll('input, select, textarea');
      for (const el of fields) {
        const type = (el.type || '').toLowerCase();
        if (el.disabled) continue;
        if (el.tagName === 'INPUT' && (type === 'hidden' || type === 'button' || type === 'submit' || type === 'reset' || type === 'file')) continue;
        if (el.tabIndex < 0) continue;
        if (el.offsetParent === null) continue; // not visible (covers display:none/hidden ancestors)
        el.focus({ preventScroll: true });
        try { if (typeof el.select === 'function' && (type === 'text' || type === 'email' || type === 'search' || type === 'tel' || type === 'url' || type === 'password')) el.select(); } catch(_) {}
        return true;
      }
      return false;
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      __progScroll = true;

      if (mainHeader) {
        gsap.killTweensOf(mainHeader);
        mainHeader.classList.add('header-fixed');
        gsap.set(mainHeader, { height: headerShrunkHeight });
      }

      const root = document.documentElement;
      const prevSnap = root.style.scrollSnapType || '';
      const prevBehavior = root.style.scrollBehavior || '';
      root.style.scrollSnapType = 'none';
      root.style.scrollBehavior = 'smooth';

      const top = Math.max(window.scrollY + target.getBoundingClientRect().top - OFFSET, 0);
      window.scrollTo({ top, left: 0, behavior: 'smooth' });

      const restore = () => {
        // final correction (in case layout shifted)
        const fix = Math.max(window.scrollY + target.getBoundingClientRect().top - OFFSET, 0);
        if (Math.abs(fix - window.scrollY) > 1) window.scrollTo({ top: fix, left: 0, behavior: 'auto' });

        // focus the first field without causing another scroll
        focusFirstField(target);

        root.style.scrollSnapType = prevSnap;
        root.style.scrollBehavior = prevBehavior;
        __progScroll = false;
        updateHeaderOffsetPadding();
        ScrollTrigger.refresh();
      };

      if ('onscrollend' in window) window.addEventListener('scrollend', restore, { once: true });
      else setTimeout(restore, 600);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSmoothScroll);
  else initSmoothScroll();
})();
